import type React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';

import { useDepartmentHintTranslation } from '../../i18n';
import st from './DepartmentHint.module.sass';

function DepartmentHint(): React.JSX.Element {
  const { t } = useDepartmentHintTranslation();

  return (
    <div className={st.Root}>
      <div className={st.Header}>
        <InfoCircleFilledIcon className={st.InfoIcon} />
        {t('title')}
      </div>

      <div className={st.Section}>
        <div className={st.SubTitle}>{t('intro')}</div>
        <div className={st.SubTitle}>{t('access.title')}</div>
        <ul className={st.List}>
          <li>{t('access.item1')}</li>
          <li>{t('access.item2')}</li>
        </ul>
      </div>

      <div className={st.Section}>
        <div className={st.SubTitle}>{t('lists.title')}</div>
        <div>
          <div className={st.Description}>{t('lists.owner')}</div>
          <div className={st.Description}>{t('lists.view')}</div>
        </div>
      </div>

      <div className={st.Section}>
        <div className={st.SubTitle}>{t('users.title')}</div>
        <div className={st.Description}>{t('users.text')}</div>
      </div>

      <div className={st.Section}>
        <div className={st.SubTitle}>{t('streamGroups.title')}</div>
        <div className={st.Description}>{t('streamGroups.text')}</div>
      </div>
    </div>
  );
}

export { DepartmentHint };
